import {
    Component,
    computed,
    effect,
    EventEmitter,
    input,
    Output,
    signal,
    WritableSignal
} from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { PeriodPreset, PeriodPresetEnum } from '../../period-picker.interface';
import { parsePreset } from '../../helpers/parse-preset.function';
import dayjs from 'dayjs';
import { periodPresets } from '../../period-picker.config';

@Component({
    selector: 'app-period-picker-presets',
    templateUrl: './period-picker-presets.component.html',
    styleUrl: './period-picker-presets.component.scss',
    standalone: false
})
export class PeriodPickerPresetsComponent {
    public selected = input.required<DateRange<Date> | null>();

    public minDate = input<Date | null>(null);

    public maxRange = input<number | null>(null);

    public presets = input.required<PeriodPresetEnum[]>();

    protected currentPreset: WritableSignal<PeriodPreset | null> = signal(null);

    protected periodPresets = computed(
        () => this.presets()
            .map(presetType => periodPresets.find(preset => preset.name === presetType) || null)
            .filter(preset => {
                if (!preset || !this.presets().includes(preset.name)) {
                    return false;
                }

                const maxRange = this.maxRange();

                if (maxRange && maxRange < preset.period()) {
                    return false;
                }

                if (this.minDate() && !dayjs().subtract(preset.period(), 'days').isAfter(this.minDate())) {
                    return false;
                }

                return true;
            }) as PeriodPreset[]
    );

    @Output()
    public onPresetSelected = new EventEmitter<PeriodPreset>();

    protected setPeriod(preset: PeriodPreset): void {
        this.currentPreset.set(preset);
        this.onPresetSelected.emit(preset);
    }

    constructor() {
        effect(() => {
            const start = this.selected()?.start;
            const end = this.selected()?.end;

            if (!start || !end) {
                return this.currentPreset.set(null);
            }

            this.currentPreset.set(parsePreset(start, end) || null);
        });
    }
}
